import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {CompareProfileComponent} from './compare-profile/compare-profile.component';
import {AnonymousGuard} from '../auth/anonymous-guard.service';
import {AuthGuard} from '../auth/auth-guard.service';

const compareRoutes: Routes = [
  {
    path: 'compare/profile', component: CompareProfileComponent, canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(compareRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class CompareRoutingModule {}
